module.exports = __webpack_public_path__ + "static/exercise-img-1-4fb1be812118a3f852899df524ce8aa1.png";